import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import i18n from './index';

interface LanguageState {
  currentLanguage: string;
  setLanguage: (language: string) => Promise<void>;
  isLoading: boolean;
}

export const useLanguageStore = create<LanguageState>()(
  persist(
    (set) => ({
      currentLanguage: i18n.language || 'en',
      isLoading: false,
      setLanguage: async (language: string) => {
        try {
          // Ensure we have a valid string language code
          if (typeof language !== 'string' || !language.trim()) {
            console.error('Invalid language code provided:', language);
            return;
          }

          const languageCode = language.trim();
          
          set({ isLoading: true });
          
          // Change the i18next language with the string code
          await i18n.changeLanguage(languageCode);
          
          // Update the store state
          set({ currentLanguage: languageCode });
          
          // Store in localStorage for persistence
          localStorage.setItem('i18nextLng', languageCode);
          
        } catch (error) {
          console.error('Error changing language:', error);
        } finally {
          set({ isLoading: false });
        }
      },
    }),
    {
      name: 'language-store',
      partialize: (state) => ({ currentLanguage: state.currentLanguage }),
    }
  )
);